import { api } from "../api/api";
import { ApiResponse } from "../models/base/ApiResponse";
import { CreateLocalEventDTO, UpdateLocalEventDTO } from "../models/localEvent/localEvent.request";
import { LocalEventSettingsDTO, LocalEventTableItemDTO } from "../models/localEvent/localEvent.response";


export const localEventService = {

    async Create(localId: string, newLocalEvent: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.post<ApiResponse<string>>(`/locals/${localId}/events`, newLocalEvent);
        return data;
    },

    async Update(localId: string, id: string, updatedLocalEvent: FormData): Promise<ApiResponse<string>> {
        const { data } = await api.put<ApiResponse<string>>(`/locals/${localId}/events/${id}`, updatedLocalEvent);
        return data;
    },

    async Delete(localId: string, id: string): Promise<ApiResponse<string>> {
        const { data } = await api.delete<ApiResponse<string>>(`/locals/${localId}/events/${id}`);
        return data;
    },

    async GetSettings(localId: string, settingId: string): Promise<ApiResponse<LocalEventSettingsDTO>> {
        const { data } = await api.get<ApiResponse<LocalEventSettingsDTO>>(`/locals/${localId}/events/settings/${settingId}`);
        return data;
    },

    async GetForTableSettings(localId: string): Promise<ApiResponse<LocalEventTableItemDTO[]>> {
        const { data } = await api.get<ApiResponse<LocalEventTableItemDTO[]>>(`/locals/${localId}/events/settings`);
        return data;
    }

}
